import distanceBetweenPoints from './distanceBetweenPoints'

export default function sortByDistance (list: any[], location : {lat: number, lng: number}) {
  const sorted = list.sort((a, b) => {
    const distanceFromA = distanceBetweenPoints({ lat: location.lat, lng: location.lng }, a.position)
    const distanceFromB = distanceBetweenPoints({ lat: location.lat, lng: location.lng }, b.position)
    if (distanceFromA > distanceFromB) {
      return 1
    }
    if (distanceFromA < distanceFromB) {
      return -1
    }
    return 0
  })
  return sorted
}
